var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HasuraStorageApi } from './hasura-storage-api';
var HasuraStorageClient = /** @class */ (function () {
    function HasuraStorageClient(_a) {
        var url = _a.url;
        this.url = url;
        this.api = new HasuraStorageApi({ url: url });
    }
    /**
     *
     * Use `.upload` to upload a file.
     *
     * @example
     *
     * storage.upload({ file })
     *
     */
    HasuraStorageClient.prototype.upload = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var file, _a, fileMetadata, error;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        file = new FormData();
                        file.append('file', params.file);
                        return [4 /*yield*/, this.api.upload(__assign(__assign({}, params), { file: file }))];
                    case 1:
                        _a = _b.sent(), fileMetadata = _a.fileMetadata, error = _a.error;
                        if (error) {
                            return [2 /*return*/, { fileMetadata: null, error: error }];
                        }
                        if (!fileMetadata) {
                            return [2 /*return*/, { fileMetadata: null, error: new Error('Invalid file returned') }];
                        }
                        return [2 /*return*/, { fileMetadata: fileMetadata, error: null }];
                }
            });
        });
    };
    /**
     *
     * Use `.getUrl` to direct file URL to a file.
     *
     * @example
     *
     * storage.getUrl({ fileId: 'uuid' })
     *
     */
    HasuraStorageClient.prototype.getUrl = function (params) {
        var fileId = params.fileId;
        return this.url + "/files/" + fileId;
    };
    /**
     *
     * Use `.getPresignedUrl` to get a presigned URL to a file.
     *
     * @example
     *
     * storage.getPresignedUrl({ fileId: 'uuid' })
     *
     *
     */
    HasuraStorageClient.prototype.getPresignedUrl = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, presignedUrl, error;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.api.getPresignedUrl(params)];
                    case 1:
                        _a = _b.sent(), presignedUrl = _a.presignedUrl, error = _a.error;
                        if (error) {
                            return [2 /*return*/, { presignedUrl: null, error: error }];
                        }
                        if (!presignedUrl) {
                            return [2 /*return*/, { presignedUrl: null, error: new Error('Invalid file id') }];
                        }
                        return [2 /*return*/, { presignedUrl: presignedUrl, error: null }];
                }
            });
        });
    };
    /**
     *
     * Use `.delete` to delete a file.
     *
     * @example
     *
     * storage.delete({ fileId: 'uuid' })
     *
     *
     */
    HasuraStorageClient.prototype.delete = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.delete(params)];
                    case 1:
                        error = (_a.sent()).error;
                        if (error) {
                            return [2 /*return*/, { error: error }];
                        }
                        return [2 /*return*/, { error: null }];
                }
            });
        });
    };
    HasuraStorageClient.prototype.setAccessToken = function (accessToken) {
        this.api.setAccessToken(accessToken);
    };
    return HasuraStorageClient;
}());
export { HasuraStorageClient };
//# sourceMappingURL=hasura-storage-client.js.map